import { Config } from '@/config';
import { ApiService } from '@/services/api.service';
import axios from 'axios';

const CancelToken = axios.CancelToken;
let cancelTokens = {
  potentialBidders: null,
};

class PotentialBiddersService {
  getPotentialBidders(opportunityId) {
    if (cancelTokens.potentialBidders) cancelTokens.potentialBidders.cancel('Multiple requests.');
    cancelTokens.potentialBidders = CancelToken.source();

    return ApiService.get(`${Config.api.document.url}api/v1/opportunities/${opportunityId}/potential-bidders`, {
      cancelToken: cancelTokens.potentialBidders.token,
    }).then((response) => response.data);
  }

  createPotentialBidder(opportunityId, potentialBidder) {
    return ApiService.post(
      `${Config.api.document.url}api/v1/opportunities/${opportunityId}/potential-bidders`,
      potentialBidder,
    ).then((response) => response.data);
  }

  editPotentialBidder(opportunityId, potentialBidderId, potentialBidder) {
    return ApiService.put(
      `${Config.api.document.url}api/v1/opportunities/${opportunityId}/potential-bidders/${potentialBidderId}`,
      potentialBidder,
    ).then((response) => response.data);
  }

  deletePotentialBidder(opportunityId, potentialBidderId) {
    return ApiService.delete(
      `${Config.api.document.url}api/v1/opportunities/${opportunityId}/potential-bidders/${potentialBidderId}`,
    );
  }
}

export const potentialBiddersService = new PotentialBiddersService();
